import React from 'react';
import './profile-card.style.css';
import UserContext from '../../utils/userContext'
import axios from 'axios'
import {
    Link, Redirect,
} from 'react-router-dom'


export default class UserProfileSideMenu extends React.Component {
    static contextType = UserContext
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            userImage: "",
            notFound: false
        };
    }

    componentDidMount() {
        if (this.context.userData.nicename !== this.props.nicename) {
            let self = this
            axios({
                method: 'get',
                url: `https://www.borntodev.com/wp-json/devblog/v1/users/${this.props.nicename}`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(function (response) {

                    self.setState({ username: response.data.userName, userImage: response.data.userImage, nicename: response.data.userNicename })
                })
                .catch(function (response) {
                    self.setState({ notFound: true })

                });
        } else {
            this.setState({ username: this.context.userData.displayName, userImage: this.context.userData.profileImage, nicename: this.context.userData.nicename })
        }
    }


    render() {
        return (
            <>
                {this.state.notFound ? <Redirect to="/404" /> : <></>}
                <ProfileSideMenu authorImage={this.state.userImage} authorName={this.state.username} nicename={this.state.nicename} />
            </>
        )
    }
}

const ProfileSideMenu = (props) => {
    return (
        <div className="profile-side-menu">

            <div className="profile-head-cover">
            </div>

            <div className="author-image-name">
                <Link to={`/${props.nicename}/`}>
                    <div className="author-image" style={{ backgroundImage: `url(${props.authorImage})` }}>
                    </div>
                </Link>
                <Link to={`/${props.nicename}/`}>
                    <div className="author-name">
                        {props.authorName}
                    </div>
                </Link>
            </div>
            <div className="profile-des-wrap">
                {/* <div className="profile-des">
                    Software Engineer, biblephile, & cat mom
                </div>
                <div className="profile-follow-button">
                    Follow
                </div>
                <div className="profile-detail-topic">
                    WORK
                </div>
                <div className="profile-detail-des">
                    Software Engineer <span className="sub-des">at</span> Spotify
                </div>
                <div className="profile-detail-topic">
                    LOCATION
                </div>
                <div className="profile-detail-des">
                    Stockholm
                </div>
                <div className="profile-detail-topic">
                    EDUCATION
                </div>
                <div className="profile-detail-des">
                    Siena College
                </div>

                <div className="profile-detail-topic">
                    JOINED
                </div>
                <div className="profile-detail-des">
                    Dec 22, 2018
                </div> */}



            </div>

        </div>
    )
}


export { ProfileSideMenu };
